<app-secondary-toolbar [parents]="breadcrumbParents" [self]="taskRecordName" [actions]="toolbarActions">
</app-secondary-toolbar>
<div class="helpdesk-button-container" *ngIf="grantedRights.update.hasRight() && canModify(taskRecordState)">
  <button type="button" class="btn btn-primary helpdesk-main-button"
          [class.helpdesk-has-actions]="canValidate(taskRecordState) || canInvalidate(taskRecordState)"
          uiSref="Helpdesk.BugReportEdit" [uiParams]="{taskId: taskId, taskRecordId: taskRecordId}">
    {{'COMMON_BUTTON_EDIT' | translate}}
  </button>
  <button type="button" class="btn btn-primary helpdesk-dropdown-button"
          *ngIf="canValidate(taskRecordState) || canInvalidate(taskRecordState)"
          dropdown href="#" onclick="return false"
          dropdownToggle container="body" placement=""
          data-toggle="dropdown" role="button"
          aria-haspopup="true" aria-expanded="false">
    <i class="icomoon icomoon-dropdown"></i>
    <div class="dropdown-menu dropdown-menu-right border-bottom-0"
         *dropdownMenu aria-labelledby="simple-dropdown">
      <app-dropdown-item
        *ngIf="canValidate(taskRecordState)"
        [iconClass]="'icomoon-helpdesk-validate'"
        [titleStringKey]="'HELPDESK_BUG_REPORT_ACTION_VALIDATE'"
        class="cursor-pointer"
        (click)="setBugReportState('FINISHED', taskRecordId)">
      </app-dropdown-item>
      <app-dropdown-item
        *ngIf="canInvalidate(taskRecordState)"
        [iconClass]="'icomoon-helpdesk-reject'"
        [titleStringKey]="'HELPDESK_BUG_REPORT_ACTION_INVALIDATE'"
        class="cursor-pointer"
        (click)="setBugReportState('IN_PROGRESS', taskRecordId)">
      </app-dropdown-item>
    </div>
  </button>
</div>
<div class="container-horizontal-padding container-vertical-padding animated fadeIn">
  <responsive-tabset class="fullscreen_tab">
    <responsive-tab
      heading="{{(appTypeHelperService.isHelpdesk() ? 'BUG_REPORT_PANEL_HEADING_DETAIL' : 'TASK_RECORD_PANEL_HEADING_DETAIL')|translate}}">
      <form class="form-horizontal bordered-row" (ngSubmit)="nothing()" #f="ngForm" novalidate>
        <app-new-task-record-base
          [readonly]="true"
          [allowClone]="true"
          [allowStateChange]="true"
          (stateChange)="preStateChange($event)"
          (settableStateListEmitter)="settableStateListLoader($event)"
          [allowExport]="true"
          (customerRecordChanged)="onCustomerRecordChanged()"
          (assigneeUserChanged)="onAssigneeUserChanged()"
          (selectedAddressChanged)="onSelectedAddressChanged()"
          [form]="f">
        </app-new-task-record-base>
        <app-form-record-container
          [readonly]="true"
          [cloning]="false"
          [form]="f">
        </app-form-record-container>
      </form>
      <div class="container-vertical-padding-half"></div>
      <app-task-record-signature
        [taskRecordId]="taskRecordId"
        [taskId]="taskId"
        [task]="combinedResult?.task"
        [grantedRights]="grantedRights"
        [taskRecordState]="taskRecordState">
      </app-task-record-signature>
    </responsive-tab>
    <responsive-tab heading="{{'COMMON_PANEL_HEADING_ATTACHMENT'|translate}}" id="attachments"
    (selectTab)="attachmentView.showData()"
    >
      <app-task-record-attachment #attachmentView
                                  [taskId]="taskId"
                                  [grantedRights]="grantedRights"
                                  [taskRecordId]="taskRecordId"
                                  [readonly]="true">
      </app-task-record-attachment>
    </responsive-tab>
    <responsive-tab *ngIf="grantedRights.logRead.hasRight()"
                    id="history"
                    heading="{{'TASK_RECORD_PANEL_HEADING_HISTORY'|translate}}">
      <app-task-record-history
        [taskId]="taskId"
        [taskRecordId]="taskRecordId">
      </app-task-record-history>
      <app-trigger-history
        *ngIf="rightModel.taskTriggerInstanceRead.hasRight()"
        [triggerService]="getTaskRecordService()"
        [triggerParentId]="taskId"
        [instanceParentId]="taskRecordId"
        [scope]="'TASK'">
      </app-trigger-history>
    </responsive-tab>
    <responsive-tab heading="{{'TASK_RECORD_PANEL_HEADING_PDF'|translate}}" id="pdfs"
    *ngIf="grantedRights.documentRead.hasRight()">
      <app-task-record-pdf
        [taskId]="taskId"
        [taskRecordId]="taskRecordId"
        [taskRecordState]="taskRecordState">
      </app-task-record-pdf>
    </responsive-tab>
    <responsive-tab *ngIf="combinedResult && configurationService.getConfiguration().feature_flags.sms_futar_enabled && !appTypeHelperService.isHelpdesk()"
                    heading="{{'TASK_SMS_RATING'|translate}}"
                    id="smsRating">
      <app-task-record-sms-rating
        [smsRating]="combinedResult.taskRecord.smsRating"
        [smsContent]="combinedResult.taskRecord.smsContent">
      </app-task-record-sms-rating>
    </responsive-tab>
    <responsive-tab heading="{{'TASK_RECORD_PANEL_HEADING_SURVEY'|translate}}" id="surveys"
                    *ngIf="isTaskRecordManagedField('SURVEYS') && rightModel.surveyRead.hasRight() && !appTypeHelperService.isHelpdesk()">
      <app-task-record-survey #surveyView (refresh)="onRefresh()">
      </app-task-record-survey>
    </responsive-tab>
    <responsive-tab heading="{{'COMMON_MESSAGES'|translate}}" id="messages"
                    *ngIf="grantedRights.chatRead.hasRight()"
                    (selectTab)="taskRecordMessageList.initComponent()">
      <app-chat
        #taskRecordMessageList
        [parentId]="taskId"
        [id]="taskRecordId"
        [messageSendEnable]="grantedRights.chatMessageCreate.hasRight()"
        [chatService]="getChatService()">
      </app-chat>
    </responsive-tab>
    <responsive-tab heading="{{'PROCESS_MESSAGE_LIST'|translate}}" id="processMessages"
                    *ngIf="processId && rightModel.processRead.hasRight()"
                    (selectTab)="processMessageList.initComponent()">
      <app-chat
        #processMessageList
        [id]="processId"
        [messageSendEnable]="true"
        [chatService]="getProcessChatService()">
      </app-chat>
    </responsive-tab>
    <responsive-tab heading="{{'INVOICE_CREATE_RELATED_TASKS'|translate}}" id="relatedTasks"
                    *ngIf="!appTypeHelperService.isHelpdesk()"
                    (selectTab)="taskRecordRelatedTasks.initComponent()">
      <app-task-record-related-tasks
        #taskRecordRelatedTasks
        [customerRecordId]="customerRecordId"
        [taskId]="taskId"
        [taskRecordId]="taskRecordId">
      </app-task-record-related-tasks>
    </responsive-tab>
    <responsive-tab heading="{{'CUSTOMER_RECORD_PHONE_NUMBER_RELATED'|translate}}"
                    *ngIf="customerRecordId && config.taskRecordPhoneNumberRelatedList && !appTypeHelperService.isHelpdesk()">
      <app-new-task-record-list
        [baseCustomerRecordByPhoneNumberId]="customerRecordId"
        [_headerStringKey]="'CUSTOMER_RECORD_PHONE_NUMBER_RELATED'">
      </app-new-task-record-list>
    </responsive-tab>
    <responsive-tab heading="{{'TASK_RECORD_SUB_TASKS'|translate}}" id="subTasks"
                    *ngIf="rightModel.taskRecordSubTaskRead.hasRight() && !appTypeHelperService.isHelpdesk()"
                    (selectTab)="taskRecordSubTask.initComponent()">
      <app-task-record-sub-task
        #taskRecordSubTask
        [taskId]="taskId"
        [taskRecordId]="taskRecordId"
        (onSubTaskCreateEditDialogButtonClicked)="taskRecordSubTaskCreateEditDialog.showSubTaskCreateEditDialog($event)"
        (onSubTaskDetailDialogButtonClicked)="taskRecordSubTaskDetailDialog.showSubTaskDetailDialog($event)"
        (onSubTaskDeleteDialogButtonClicked)="taskRecordSubTaskDeleteDialog.showDeleteSubTaskDialog($event)">
      </app-task-record-sub-task>
    </responsive-tab>
    <responsive-tab heading="{{'INVOICES_LIST_HEADING'|translate}}" id="invoices"
                    *ngIf="rightModel.invoiceRead.hasRight()"
                    (selectTab)="taskRecordInvoice.initComponent()">
      <app-task-record-invoice
        #taskRecordInvoice
        [taskId]="taskId"
        [taskRecordId]="taskRecordId">
      </app-task-record-invoice>
    </responsive-tab>
    <responsive-tab heading="{{'WORKLOG_PANEL_HEADING_LIST'|translate}}" id="worklog"
                    *ngIf="rightModel.worklogRead.hasRight() && !appTypeHelperService.isHelpdesk()">
      <app-worklog-list
        #worklogList
        [scope]="WorklogScope.TASK_RECORD"
        [resourceParentId]="taskId"
        [editable]="false"
        [createEnabled]="false"
        [resourceId]="taskRecordId">
      </app-worklog-list>
    </responsive-tab>
    <responsive-tab heading="{{'MENU_NAVBAR_MILEAGE_RECORDS'|translate}}" id="mileageRecords"
                    *ngIf="rightModel.mileageRecordRead.hasRight() && mileageRecordEnabled && !appTypeHelperService.isHelpdesk()">
      <app-task-record-mileage-record
        #mileageRecordList
        (onMileageRecordEditClicked)="mileageRecordUpdateDialog.showDialog($event)"
        [rightModel]="rightModel"
        [taskRecordId]="taskRecordId">
      </app-task-record-mileage-record>
    </responsive-tab>
    <responsive-tab heading="{{'MENU_NAVBAR_OUTGOING_SMS'|translate}}"
                    *ngIf="rightModel.outgoingSmsRead.hasRight() && !appTypeHelperService.isHelpdesk()">
      <app-task-record-outgoing-sms-list
              #outgoingSmsList
              [rightModel]="rightModel"
              [taskId]="taskId"
              [taskRecordId]="taskRecordId">
      </app-task-record-outgoing-sms-list>
    </responsive-tab>
  </responsive-tabset>
</div>

<app-task-record-sub-task-create-edit-dialog
  #taskRecordSubTaskCreateEditDialog
  [taskId]="taskId"
  [taskRecordId]="taskRecordId"
  (subTaskUpdated)="taskRecordSubTask.loadList()">
</app-task-record-sub-task-create-edit-dialog>

<app-task-record-sub-task-detail-dialog
  #taskRecordSubTaskDetailDialog>
</app-task-record-sub-task-detail-dialog>

<app-task-record-sub-task-delete-dialog
  #taskRecordSubTaskDeleteDialog
  [taskId]="taskId"
  [taskRecordId]="taskRecordId"
  (onSubTaskDeleted)="taskRecordSubTask.loadList()">
</app-task-record-sub-task-delete-dialog>

<app-task-record-invoice-create-dialog
  #taskRecordInvoiceCreateDialog
  [taskId]="taskId"
  [taskRecordId]="taskRecordId"
  [selectedCustomerRecord]="baseView.getModel().customer"
  [billingInfo]="baseView.getModel().billingInfo.length === 1 ? baseView.getModel().billingInfo[0] : undefined"
  (onResult)="onInvoiceCreateResult($event)">
</app-task-record-invoice-create-dialog>

<app-mileage-record-edit-dialog
  #mileageRecordUpdateDialog
  (onMileageRecordUpdated)="mileageRecordList.loadList()">
</app-mileage-record-edit-dialog>

<div bsModal [config]="UiConstants.modalConfig" #sendMessageDialog="bs-modal" class="modal fade" tabindex="-1"
     role="dialog"
     aria-labelledby="myModalLabel"
     aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" *ngIf="sendMessageDialogVisible">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{'TASK_RECORD_EDIT_SEND_NEW_MESSAGE' | translate}}</h4>
        <button type="button" class="close" (click)="closeSendMessageDialog()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group col-md-12"
             [ngClass]="{ 'has-danger': messageSubmitted && newMessage.length === 0 }">
          <input class="form-control" type="text"
                 placeholder="{{'TASK_RECORD_DETAIL_NEW_MESSAGE' | translate}}"
                 [(ngModel)]="newMessage"
                 [ngClass]="{ 'form-control-danger': messageSubmitted && newMessage.length === 0 }">
          <div class="form-control-feedback" *ngIf="messageSubmitted && newMessage.length === 0">
            {{'TASK_RECORD_DETAIL_MESSAGE_REQUIRED' | translate}}
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeSendMessageDialog()">
          {{'COMMON_BUTTON_CANCEL' | translate}}
        </button>
        <button type="button" class="btn btn-primary" (click)="sendMessage()">{{'COMMON_BUTTON_SEND' |
          translate}}
        </button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<app-task-record-bulk-clone-dialog
  #bulkCloneDialog
  (onSuccess)="onBulkCloneSuccess($event)">
</app-task-record-bulk-clone-dialog>

<div bsModal [config]="UiConstants.modalConfig" #assigneeModificationDialog="bs-modal" class="modal fade" tabindex="-1"
     role="dialog"
     aria-labelledby="myModalLabel"
     aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" *ngIf="assigneeModificationDialogVisible">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{'TASK_SET_RESPONSIBLE' | translate}}</h4>
        <button type="button" class="close" (click)="closeAssigneeModificationDialog()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <div class="col-sm-12 p-0">
            <div class="card">
              <div class="card-body">

                <div class="form-group" *ngIf="config.assigneeWithUser">
                  <label class="edit-form-label form-control-label">{{'TASK_DATA_MODIFICATION_USER' |
                    translate}}</label>
                  <div class="edit-form-input-group">
                    <angular2-multiselect [data]="users" [settings]="dropdownSettingsWithRemoteSearch"
                                          class="form-control"
                                          [(ngModel)]="assigneeModificationModel._assigneeUser"
                                          (onRemoteSearch)="onAssigneeUserSearch($event.target.value)"
                                          #dataModificationAssigneeUser="ngModel"
                                          name="dataModificationAssigneeUser"
                                          id="dataModificationAssigneeUser">
                    </angular2-multiselect>
                  </div>
                </div>

                <div class="form-group" *ngIf="config.assigneeWithMobileApp">
                  <label class="edit-form-label form-control-label">{{'TASK_DATA_MODIFICATION_DEVICE' |
                    translate}}</label>
                  <div class="edit-form-input-group">
                    <angular2-multiselect [data]="devices" [settings]="dropdownSettingsWithRemoteSearch"
                                          class="form-control"
                                          (onRemoteSearch)="onDeviceSearch($event.target.value)"
                                          [(ngModel)]="assigneeModificationModel._assigneeMobileApp"
                                          #dataModificationAssigneeMobileApp="ngModel"
                                          name="dataModificationAssigneeMobileApp"
                                          id="dataModificationAssigneeMobileApp">
                    </angular2-multiselect>
                  </div>
                </div>
              </div>
            </div>
          </div><!--/.col-->
        </div>

      </div><!-- /.modal-body -->

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeAssigneeModificationDialog()">
          {{'COMMON_BUTTON_CANCEL' | translate}}
        </button>
        <button type="button" class="btn btn-primary" (click)="changeAssigneeInProgress()">
          {{'COMMON_BUTTON_SAVE_CHANGES' |
          translate}}
        </button>
      </div><!-- /.modal-footer -->
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
